export enum ELessonType {
    Scorm12 = 0,
    AICC = 1,
    TinCan = 2
}